<template>
  <div class="res-page">
    <!-- Decorative top strip -->
    <div class="res-top-strip"></div>

    <div class="res-container">

      <!-- Header -->
      <div class="res-header">
        <div class="res-header-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
          </svg>
        </div>
        <h1 class="res-header-title">تسجيل حجز جديد</h1>
        <p class="res-header-sub">أكمل البيانات التالية للحجز في مجموعات أ/ طارق عبدالباري</p>
      </div>

      <!-- Form card -->
      <div class="res-card">
        <form @submit.prevent="sendForm" novalidate>

          <!-- ── Section 1: Personal info ── -->
          <div class="res-section">
            <div class="res-section-head">
              <div class="res-section-dot"></div>
              <span>البيانات الشخصية</span>
            </div>
            <div class="res-grid res-grid--2">

              <!-- Student name -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.student_name.$error }">
                <label class="rf-label">اسم الطالب <span class="rf-req">*</span></label>
                <div class="rf-input-wrap">
                  <span class="rf-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  </span>
                  <input type="text" v-model="student_name" class="rf-input" placeholder="الاسم رباعياً" />
                </div>
                <span class="rf-error" v-if="v$.student_name.$error">برجاء إدخال اسم الطالب</span>
              </div>

              <!-- Gender -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.selected_gender.$error }">
                <label class="rf-label">الجنس <span class="rf-req">*</span></label>
                <div class="rf-pill-group">
                  <button type="button" v-for="g in genders" :key="g.id"
                    class="rf-pill" :class="{ 'rf-pill--active': selected_gender?.id === g.id }"
                    @click="selected_gender = g">
                    {{ g.id === 1 ? '👦' : '👧' }} {{ g.name }}
                  </button>
                </div>
                <span class="rf-error" v-if="v$.selected_gender.$error">برجاء اختيار الجنس</span>
              </div>

            </div>
          </div>

          <!-- ── Section 2: Phone numbers ── -->
          <div class="res-section">
            <div class="res-section-head">
              <div class="res-section-dot"></div>
              <span>أرقام التواصل</span>
            </div>
            <div class="res-grid res-grid--2">

              <!-- Student phone -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.student_phone.$error }">
                <label class="rf-label">
                  رقم هاتف الطالب <span class="rf-req">*</span>
                  <span class="rf-hint">(أو رقم ولي الأمر إن لم يتوافر)</span>
                </label>
                <div class="rf-input-wrap">
                  <span class="rf-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 01.22 2.38 2 2 0 012.2.22h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.1 6.1l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  </span>
                  <input type="tel" v-model="student_phone" class="rf-input" placeholder="01XXXXXXXXX" dir="ltr" @keypress="onlyNumbers" inputmode="tel" />
                </div>
                <span class="rf-error" v-if="v$.student_phone.$error">برجاء إدخال رقم هاتف الطالب</span>
              </div>

              <!-- Parent phone -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.parent_phone.$error }">
                <label class="rf-label">رقم هاتف ولي الأمر <span class="rf-req">*</span></label>
                <div class="rf-input-wrap">
                  <span class="rf-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 01.22 2.38 2 2 0 012.2.22h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.1 6.1l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                  </span>
                  <input type="tel" v-model="parent_phone" class="rf-input" placeholder="01XXXXXXXXX" dir="ltr" @keypress="onlyNumbers" inputmode="tel" />
                </div>
                <span class="rf-error" v-if="v$.parent_phone.$error">برجاء إدخال رقم هاتف ولي الأمر</span>
              </div>

            </div>
          </div>

          <!-- ── Section 3: Academic info ── -->
          <div class="res-section">
            <div class="res-section-head">
              <div class="res-section-dot"></div>
              <span>البيانات التعليمية</span>
            </div>
            <div class="res-grid res-grid--3">

              <!-- Address -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.address.$error }">
                <label class="rf-label">العنوان <span class="rf-req">*</span></label>
                <div class="rf-input-wrap">
                  <span class="rf-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  </span>
                  <input type="text" v-model="address" class="rf-input" placeholder="المدينة / الحي" />
                </div>
                <span class="rf-error" v-if="v$.address.$error">برجاء إدخال العنوان</span>
              </div>

              <!-- Math degree -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.math_degree.$error }">
                <label class="rf-label">
                  درجة الرياضيات <span class="rf-req">*</span>
                  <span class="rf-hint">(الصف الثاني الإعدادي)</span>
                </label>
                <div class="rf-input-wrap">
                  <span class="rf-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
                  </span>
                  <input type="text" v-model="math_degree" class="rf-input" placeholder="مثال: 85" dir="ltr" @keypress="onlyNumbers" inputmode="numeric" />
                </div>
                <span class="rf-error" v-if="v$.math_degree.$error">برجاء إدخال درجة الرياضيات</span>
              </div>

              <!-- Education type -->
              <div class="rf-field" :class="{ 'rf-field--error': v$.selected_type.$error }">
                <label class="rf-label">نظام التعليم <span class="rf-req">*</span></label>
                <div class="rf-pill-group">
                  <button type="button" v-for="t in types" :key="t.id"
                    class="rf-pill" :class="{ 'rf-pill--active': selected_type?.id === t.id }"
                    @click="selected_type = t">
                    {{ t.name }}
                  </button>
                </div>
                <span class="rf-error" v-if="v$.selected_type.$error">برجاء اختيار نظام التعليم</span>
              </div>

            </div>
          </div>

          <!-- ── Section 4: Certificate image ── -->
          <div class="res-section">
            <div class="res-section-head">
              <div class="res-section-dot"></div>
              <span>صورة الشهادة <small style="font-weight:400;color:#9CA3AF">(الصف الثاني الإعدادي)</small></span>
            </div>

            <!-- Upload area -->
            <label for="certificateImage" class="res-upload" :class="{ 'res-upload--has-file': imageEntry, 'res-upload--error': v$.fileData.$error }">
              <!-- Preview -->
              <img v-if="imageEntry" :src="imageEntry" class="res-upload-preview" alt="صورة الشهادة" />

              <!-- Empty state -->
              <div v-else class="res-upload-empty">
                <div class="res-upload-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                </div>
                <p class="res-upload-text">اضغط لرفع صورة الشهادة</p>
                <p class="res-upload-hint">PNG, JPG, JPEG (حتى 5MB)</p>
              </div>

              <!-- File name badge -->
              <div v-if="imageEntry" class="res-upload-name">
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13.25 4.25l-3.5-3.5H3.75A1.5 1.5 0 002.25 2.25v11.5a1.5 1.5 0 001.5 1.5h8.5a1.5 1.5 0 001.5-1.5v-9.5z"/></svg>
                {{ fileData?.name }}
              </div>
            </label>
            <input type="file" id="certificateImage" @change="onFileChange" hidden accept="image/png, image/gif, image/jpeg, image/jpg" />

            <div class="res-upload-note">
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" class="res-note-icon"><circle cx="8" cy="8" r="6.5"/><path d="M8 5v4M8 10.5v.5"/></svg>
              برجاء احضار الشهادة الأصلية أول حصة لدخول الدرس
            </div>
            <span class="rf-error" v-if="v$.fileData.$error">برجاء رفع صورة الشهادة</span>
          </div>

          <!-- ── Contact info ── -->
          <div class="res-contact-banner">
            <div class="res-contact-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div class="res-contact-body">
              <p class="res-contact-label">واجهتك مشكلة في الحجز؟ تواصل معنا عبر الواتساب</p>
              <div class="res-contact-links">
                <a href="https://wa.me/+201111488849" target="_blank" class="res-wa-link">01111488849</a>
                <span class="res-contact-or">أو</span>
                <a href="https://wa.me/+201021631271" target="_blank" class="res-wa-link">01021631271</a>
              </div>
            </div>
          </div>

          <!-- ── Submit ── -->
          <div class="res-submit-row">
            <button type="submit" class="res-submit" :disabled="formSending">
              <span v-if="!formSending">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:18px;height:18px;vertical-align:middle;margin-left:6px"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke-linecap="round" stroke-linejoin="round"/></svg>
                إرسال طلب الحجز
              </span>
              <span v-else class="res-spinner"></span>
            </button>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { websiteTexts } from '@/websiteTexts';

export default {
  name: "reservation-page",
  data() {
    return {
      v$: useVuelidate(),
      student_name: "",
      student_phone: null,
      parent_phone: null,
      address: "",
      math_degree: null,
      certificate_image: "",
      imageEntry: "",
      fileData: "",
      formSending: false,
      selected_gender: null,
      selected_type: null,
      genders: [
        { name: 'ولد', id: 1 },
        { name: 'بنت', id: 2 },
      ],
      types: [
        { name: 'عام', id: 1 },
        { name: 'أزهر', id: 2 },
      ],
    };
  },
  computed: {
    websiteTexts() { return websiteTexts; },
  },
  validations() {
    return {
      student_name:    { required },
      student_phone:   { required },
      parent_phone:    { required },
      selected_gender: { required },
      selected_type:   { required },
      address:         { required },
      math_degree:     { required },
      fileData:        { required },
    };
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = () => (this.imageEntry = reader.result);
    },
    onlyNumbers(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9٠-٩]/.test(char)) { event.preventDefault(); return; }
      const value = event.target.value;
      const digitsCount = (value.match(/[0-9٠-٩]/g) || []).length;
      if (digitsCount >= 11) event.preventDefault();
    },
    toEnglishDigits(str) {
      if (!str) return str;
      return str.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
    },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('student_name', this.student_name);
        formData.append('student_phone', this.toEnglishDigits(this.student_phone));
        formData.append('parent_phone', this.toEnglishDigits(this.parent_phone));
        formData.append('address', this.address);
        formData.append('gender', this.selected_gender.id);
        formData.append('education_type', this.selected_type.id);
        formData.append('math_degree', this.toEnglishDigits(String(this.math_degree).replace(/,/g, '.')));
        formData.append('education_level', 3);
        if (this.fileData instanceof File) formData.append("certificate_image", this.fileData);
        this.formSending = true;

        axios.post('/register', formData)
          .then((response) => {
            this.formSending = false;
            this.resetForm();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "رقم الهاتف الخاص بك  " + response.data.data.phone,
              html: websiteTexts.data.success_form_book?.replace(/&nbsp;/g, ' ') || '',
            });
          })
          .catch((error) => {
            this.formSending = false;
            Swal.fire({ position: "center", icon: "error", title: error.response.data.message });
          });
      }
    },
    resetForm() {
      this.v$.$reset();
      this.student_name = "";
      this.student_phone = null;
      this.parent_phone = null;
      this.address = "";
      this.math_degree = null;
      this.certificate_image = "";
      this.imageEntry = "";
      this.fileData = "";
      this.selected_gender = null;
      this.selected_type = null;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.res-page {
  min-height: calc(100vh - 70px);
  background: #F5F7FB;
  font-family: 'Cairo', sans-serif;
  direction: rtl;
  padding-bottom: 4rem;
}

/* Top accent strip */
.res-top-strip {
  height: 4px;
  background: linear-gradient(90deg, #5B5FEF, #7C4DFF, #00C2FF);
}

.res-container { max-width: 900px; margin: 0 auto; padding: 0 1.25rem; }

/* ── Header ── */
.res-header { text-align: center; padding: 2.5rem 1rem 1.75rem; }
.res-header-icon {
  width: 72px; height: 72px;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  border-radius: 22px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 0 16px 40px rgba(91,95,239,0.3);
}
.res-header-icon svg { width: 34px; height: 34px; stroke: #fff; }
.res-header-title {
  font-size: 1.9rem; font-weight: 800; color: #1A1A1A; margin-bottom: 0.4rem;
}
.res-header-sub { font-size: 0.92rem; color: #6B7280; }

/* ── Card ── */
.res-card {
  background: rgba(255,255,255,0.97);
  border-radius: 28px;
  padding: 2.25rem 2rem;
  box-shadow: 0 20px 60px rgba(91,95,239,0.1), 0 4px 16px rgba(0,0,0,0.06);
  border: 1px solid rgba(255,255,255,0.9);
  display: flex; flex-direction: column; gap: 0;
}

/* ── Section ── */
.res-section { padding: 1.5rem 0; border-bottom: 1px solid rgba(91,95,239,0.07); }
.res-section:last-of-type { border-bottom: none; }

.res-section-head {
  display: flex; align-items: center; gap: 0.6rem;
  font-size: 0.88rem; font-weight: 800;
  color: #5B5FEF; margin-bottom: 1.1rem;
  letter-spacing: 0.02em;
}
.res-section-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF); flex-shrink: 0;
}

/* ── Grids ── */
.res-grid { display: grid; gap: 1.1rem; }
.res-grid--2 { grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); }
.res-grid--3 { grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }

/* ── Field ── */
.rf-field { display: flex; flex-direction: column; gap: 0.35rem; }
.rf-label {
  font-size: 0.83rem; font-weight: 700; color: #374151;
  display: flex; align-items: center; gap: 0.3rem; flex-wrap: wrap;
}
.rf-req { color: #EF4444; }
.rf-hint { font-size: 0.72rem; color: #9CA3AF; font-weight: 500; }

.rf-input-wrap { position: relative; display: flex; align-items: center; }
.rf-icon {
  position: absolute; right: 12px;
  width: 18px; height: 18px;
  color: #9CA3AF; pointer-events: none;
  display: flex; align-items: center; justify-content: center;
}
.rf-icon svg { width: 16px; height: 16px; }

.rf-input {
  width: 100%;
  padding: 0.78rem 2.5rem 0.78rem 1rem;
  border: 2px solid #E5E7EB;
  border-radius: 13px;
  font-family: 'Cairo', sans-serif;
  font-size: 0.92rem; color: #1A1A1A;
  background: #F9FAFB;
  outline: none;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
}
.rf-input:focus {
  border-color: #5B5FEF; background: #fff;
  box-shadow: 0 0 0 4px rgba(91,95,239,0.1);
}
.rf-field--error .rf-input { border-color: #EF4444; box-shadow: 0 0 0 4px rgba(239,68,68,0.08); }
.rf-field--error .rf-icon { color: #EF4444; }
.rf-error { font-size: 0.75rem; color: #EF4444; font-weight: 600; }

/* ── Pill group ── */
.rf-pill-group { display: flex; gap: 0.6rem; flex-wrap: wrap; }
.rf-pill {
  padding: 0.6rem 1.5rem;
  border: 2px solid #E5E7EB; border-radius: 99px;
  background: #F9FAFB;
  font-family: 'Cairo', sans-serif;
  font-size: 0.9rem; font-weight: 700; color: #6B7280;
  cursor: pointer; transition: all 0.22s;
}
.rf-pill:hover { border-color: #5B5FEF; color: #5B5FEF; background: rgba(91,95,239,0.05); }
.rf-pill--active {
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  border-color: transparent; color: #fff;
  box-shadow: 0 8px 20px rgba(91,95,239,0.28);
}

/* ── Upload ── */
.res-upload {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 0.75rem;
  border: 2.5px dashed #D1D5DB;
  border-radius: 18px;
  padding: 2rem 1.5rem;
  cursor: pointer;
  transition: all 0.25s;
  background: #F9FAFB;
  min-height: 160px;
  position: relative; overflow: hidden;
}
.res-upload:hover { border-color: #5B5FEF; background: rgba(91,95,239,0.03); }
.res-upload--has-file { border-style: solid; border-color: #22C55E; background: rgba(34,197,94,0.04); }
.res-upload--error { border-color: #EF4444; }

.res-upload-preview {
  max-height: 180px; max-width: 100%;
  object-fit: contain; border-radius: 10px;
}
.res-upload-empty { display: flex; flex-direction: column; align-items: center; gap: 0.5rem; }
.res-upload-icon {
  width: 52px; height: 52px;
  background: rgba(91,95,239,0.08);
  border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  color: #5B5FEF;
}
.res-upload-icon svg { width: 26px; height: 26px; }
.res-upload-text { font-size: 0.92rem; font-weight: 700; color: #374151; }
.res-upload-hint { font-size: 0.76rem; color: #9CA3AF; }

.res-upload-name {
  display: flex; align-items: center; gap: 0.4rem;
  background: rgba(34,197,94,0.1);
  color: #16a34a; font-size: 0.8rem; font-weight: 700;
  padding: 0.35rem 0.85rem; border-radius: 99px;
}
.res-upload-name svg { width: 14px; height: 14px; stroke: #16a34a; }

.res-upload-note {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 0.8rem; color: #5B5FEF; font-weight: 600;
  background: rgba(91,95,239,0.06);
  border: 1px solid rgba(91,95,239,0.15);
  border-radius: 10px; padding: 0.55rem 0.85rem;
  margin-top: 0.6rem;
}
.res-note-icon { width: 15px; height: 15px; flex-shrink: 0; stroke: #5B5FEF; }

/* ── Contact banner ── */
.res-contact-banner {
  display: flex; align-items: center; gap: 1rem;
  background: linear-gradient(135deg, rgba(37,211,102,0.08), rgba(18,140,126,0.06));
  border: 1.5px solid rgba(37,211,102,0.2);
  border-radius: 16px; padding: 1rem 1.25rem;
  margin: 1.5rem 0 0;
}
.res-contact-icon {
  width: 44px; height: 44px; flex-shrink: 0;
  background: linear-gradient(135deg, #25D366, #128C7E);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 20px rgba(37,211,102,0.3);
}
.res-contact-icon svg { width: 24px; height: 24px; fill: #fff; }
.res-contact-body { flex: 1; }
.res-contact-label { font-size: 0.85rem; color: #374151; font-weight: 600; margin-bottom: 0.4rem; }
.res-contact-links { display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
.res-wa-link {
  background: rgba(37,211,102,0.12); color: #16a34a;
  padding: 0.3rem 0.85rem; border-radius: 99px;
  font-size: 0.84rem; font-weight: 800; text-decoration: none;
  transition: all 0.2s;
}
.res-wa-link:hover { background: #25D366; color: #fff; }
.res-contact-or { font-size: 0.78rem; color: #9CA3AF; }

/* ── Submit ── */
.res-submit-row { display: flex; justify-content: center; padding-top: 1.75rem; }
.res-submit {
  padding: 1rem 3.5rem;
  border: none; border-radius: 99px;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  color: #fff;
  font-family: 'Cairo', sans-serif;
  font-size: 1.05rem; font-weight: 800;
  cursor: pointer;
  box-shadow: 0 16px 40px rgba(91,95,239,0.35);
  transition: all 0.3s;
  display: flex; align-items: center; justify-content: center;
  min-height: 56px; min-width: 220px;
}
.res-submit:hover:not(:disabled) { transform: translateY(-4px); box-shadow: 0 24px 55px rgba(91,95,239,0.45); }
.res-submit:disabled { opacity: 0.75; cursor: not-allowed; }

.res-spinner {
  width: 24px; height: 24px;
  border: 3px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: resSpin 0.8s linear infinite; display: inline-block;
}
@keyframes resSpin { to { transform: rotate(360deg); } }

@media (max-width: 640px) {
  .res-card { padding: 1.5rem 1.1rem; border-radius: 20px; }
  .res-header-title { font-size: 1.5rem; }
  .res-submit { width: 100%; padding: 1rem; }
  .res-contact-banner { flex-direction: column; text-align: center; }
  .res-contact-links { justify-content: center; }
}
</style>
